@let v = value();

@switch (v.type) {
  @case ('GROUP') {
    <div
      class="text-text-primary mx-1 inline-block h-full rounded-md border-3 border-purple-300 bg-purple-50 p-4 text-3xl font-bold select-none"
    >
      {{ v.value }}
    </div>
  }
  @case ('KLANK') {
    @if (v.value === 'a(a)' || v.value === 'e(e)' || v.value === 'o(o)' || v.value === 'u(u)') {
      <rid-compressable-klank-card #compressable class="text-klankgroep-normaal font-bold" [content]="getWrittenText(v)" />
    } @else if (v.value === 'sjwa' || v.value === 'ig' || v.value === 'lijk') {
      <rid-compressable-klank-card #compressable class="text-klankgroep-stom italic" [content]="getWrittenText(v)" />
    } @else {
      <rid-compressable-klank-card #compressable [content]="v.value" />
    }
  }
  @case ('EXCEPTION') {
    <rid-compressable-klank-card #compressable class="font-bold text-orange-500" [content]="getWrittenText(v)" />
  }
  @case ('SPACE') {
    <rid-compressable-klank-card #compressable class="opacity-50" content="⎵" />
  }
  @case ('KLANKVOET') {
    <div class="border-surface-300 ease-out-back mx-1 inline-block h-full content-center rounded-md border-3 bg-white p-4 transition-all">
      @switch (v.value) {
        @case ('>') {
          <i-klankvoet-normal class="text-klankgroep-normaal size-[1.5lh]" />
        }
        @case ('<') {
          <i-klankvoet-stom class="text-klankgroep-stom size-[1.5lh]" />
        }
      }
    </div>
  }
  @case ('RULE') {
    <div class="font-family-din mx-1 inline-block h-full rounded-md border-3 border-dotted p-4 text-3xl font-bold text-white select-none">
      {{ v.value === '+■' ? '■' : v.value }}
    </div>
  }
}
